(function () {
    'use strict';
    var nav = document.querySelector('[data-lookout-header]');
    var burger = document.getElementById('navBurger');
    var drawer = document.getElementById('navDrawer');
    if (!nav || !burger || !drawer || nav.dataset.controllerReady) return;
    nav.dataset.controllerReady = 'true';

    function setOpen(open, restoreFocus) {
        drawer.classList.toggle('open', open);
        drawer.hidden = !open;
        burger.setAttribute('aria-expanded', String(open));
        burger.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
        if (!open && restoreFocus) burger.focus();
    }

    function scrollState() { nav.classList.toggle('scrolled', window.scrollY > 64); }
    scrollState();
    window.addEventListener('scroll', scrollState, { passive: true });
    burger.addEventListener('click', function () { setOpen(drawer.hidden); });
    drawer.querySelectorAll('a').forEach(function (link) {
        link.addEventListener('click', function () { setOpen(false); });
    });
    document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && !drawer.hidden) setOpen(false, true);
    });
    window.addEventListener('resize', function () {
        if (window.innerWidth >= 1200) setOpen(false);
    });
}());
